import { GFAFullDetails, PAGES } from "@dune/types";
import { Button, Separator } from "@dune/ui";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SECTION_TITLES } from "@dune/vars";
import { GFADocumentsTable } from "../../component/gfa/GFADocumentsTable";
import { FileWithMetadataPreviewWrapper } from "../../component/layout/FileWithMetadataPreviewWrapper";
import { useSubmitGFA } from "../../api/mutations/gfa.mutations";

interface GFAFilesFormProps {
	gfa: GFAFullDetails;
}

const GFAFilesForm = ({ gfa }: GFAFilesFormProps) => {
	const navigate = useNavigate();
	const { mutate: submitGFA, isPending: isSubmitting } = useSubmitGFA();
	return (
		<FileWithMetadataPreviewWrapper>
			<div className="flex items-center justify-center p-6 w-full">
				<div className="flex flex-col gap-6 w-full">
					<div className="flex flex-row gap-4">
						<h1 className="text-[#144C65] text-2xl font-medium">
							Pièces justificatives
						</h1>
					</div>
					<Separator />

					{/* Promoteur Files */}
					<GFADocumentsTable
						gfaConstructionSite={gfa}
						section="PROMOTER_FILES"
						title={SECTION_TITLES.PROMOTER_FILES}
					/>
					<Separator />

					{/* Legal and Commercial Files */}
					<GFADocumentsTable
						gfaConstructionSite={gfa}
						section="LEGAL_AND_COMMERCIAL_FILES"
						title={SECTION_TITLES.LEGAL_AND_COMMERCIAL_FILES}
					/>
					<Separator />

					{/* Financial Files */}
					<GFADocumentsTable
						gfaConstructionSite={gfa}
						section="FINANCIAL_FILES"
						title={SECTION_TITLES.FINANCIAL_FILES}
					/>
					<Separator />

					{/* Technical Files */}
					<GFADocumentsTable
						gfaConstructionSite={gfa}
						section="TECHNICAL_FILES"
						title={SECTION_TITLES.TECHNICAL_FILES}
					/>
					<Separator />

					{/* Action buttons */}
					<div className="self-end flex flex-row gap-4">
						<Button
							className="self-end"
							type="button"
							variant="outline"
							onClick={() => {
								navigate(
									PAGES.GFA.show.withParams(gfa.id.toString(), "documents"),
								);
							}}
						>
							Enregistrer et fermer
						</Button>
						<Button
							className="self-end"
							type="button"
							variant="default"
							disabled={isSubmitting}
							onClick={() => {
								if (gfa.id) {
									submitGFA(gfa.id);
								}
							}}
						>
							Soumettre le projet
							<ArrowRight className="w-4 h-4" />
						</Button>
					</div>
				</div>
			</div>
		</FileWithMetadataPreviewWrapper>
	);
};

export default GFAFilesForm;
